// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"9df9ced0","228":"0288f627","323":"145e553a","427":"beaa0cc3","477":"9df9ced0","699":"24fdb67c","847":"0288f627"}[chunkId] + ".chunk.css";
};